import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/zh-cn/services/toxicology/")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology", statusCode: 301 }); },
});
